import { FormPlainVariant } from '../FormPlain.types';

export const FONT_SIZE_MAPPING: Record<FormPlainVariant, number> = {
  title: 16,
  note: 16,
};

export const LINE_HEIGHT_MAPPING: Record<FormPlainVariant, number> = {
  title: 19.2,
  note: 19.2,
};
